<template>
  <div class="container-fluid">
    <search-input
      :search-block-style="'search-block-styles'"
      :input-classes="'site-search-input'"
      :iconsize="'30'"
      :iconcolor="'#c0c4d5'"
      :on-input="setSearchTerm"
      :form-action="$helpers.getSearchTermUrl(searchTerm)"
      :placeholder-value="'search'"
      :value="searchTerm"
    />

    <div v-if="searchTerm" class="wf-search-menu-dropdown-wrapper d-block">
      <div class="wf-search-menu-results-for-message w-100">
        {{ $resourceString["site.search.search.result.for"] }} "{{
          searchTerm
        }}":
      </div>
      <div
        v-if="showNoResults"
        class="wf-search-menu-no-results-message pl-4 pt-2 text-capitalize text-dark font-weight-bold"
      >
        {{ $resourceString["common.noResults"] }}
      </div>
      <div v-if="!showNoResults" class="wf-search-menu-dropdown">
        <div class="wf-search-menu-options wf-search-menu-sidemenu-displayed">
          <ul class="wf-search-menu-options-list text-uppercase">
            <li
              class="wf-search-menu-options-item"
              v-for="scopeOption in ['all', 'collections', 'styles', 'pages']"
              :key="scopeOption"
            >
              <button
                type="button"
                class="
                  wf-search-menu-options-link
                  wf-search-menu-options-link-desktop
                  btn btn-full
                  scope-button
                "
                :class="[
                  scopeOption === scope
                    ? 'wf-search-menu-options-link-active'
                    : ''
                ]"
                @click="setScope(scopeOption)"
              >
                {{ scopeOption }}
              </button>
            </li>
          </ul>
        </div>
        <div class="mobile-site-search-result">
          <mobile-search-results />
        </div>
        <div class="wf-search-menu-results mb-4">
          <search-results v-if="!isFetching" />
          <div v-if="isFetching" class="d-flex w-100 h-100">
            <div class="spinner-border primary-black m-auto" role="status">
              <span class="sr-only">{{
                $resourceString["site.search.container.loading"]
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import SearchInput from "../common/pc-search-input.vue";
import SearchResults from "./pc-site-search-results.vue";
import MobileSearchResults from "./pc-mobile-site-search-results.vue";

export default {
  components: {
    SearchInput,
    SearchResults,
    MobileSearchResults
  },
  computed: {
    ...mapGetters({
      scope: "searchMenu/scope",
      searchTerm: "searchMenu/searchTerm",
      isFetching: "searchMenu/isFetching",
      showNoResults: "searchMenu/showNoResults",
      collections: "searchMenu/collections",
      pages: "searchMenu/pages",
      products: "searchMenu/products"
    }),
    resultItems() {
      return [...this.pages, ...this.collections];
    },
    itemsAndScopeChanged() {
      return `${this.resultItems}|${this.scope}`;
    }
  },
  data() {
    return {
      timeout: null
    };
  },
  methods: {
    ...mapActions({
      setScope: "searchMenu/setScope",
      fetchQuickSearchResults: "searchMenu/fetchQuickSearchResults",
      setSearchTerm: "searchMenu/setSearchTerm"
    })
  },
  updated() {
    if(this.searchTerm) {
       document.body.style.overflow = "hidden"
    } else {
       document.body.style.overflow = ""
    }
  },
  watch: {
    searchTerm: {
      handler: function() {
        if (this.timeout) clearTimeout(this.timeout);
        if (!this.searchTerm) return;
        this.timeout = setTimeout(() => {
          this.fetchQuickSearchResults();
        }, 800);
      },
      deep: true
    },
    itemsAndScopeChanged: {
      handler: function() {
        this.$gtm.siteSearchEvent(
          this.searchTerm,
          this.resultItems,
          this.scope
        );
      },
      deep: true
    }
  }
};
</script>
